import type { LandingCompareContent, LandingConfiguratorContent } from "../types";

export const landingCompare: LandingCompareContent = {
  title: { lead: "A different model,", highlight: "by design", tail: "." },
  sub: "A direct comparison with the conventional prop-firm model on drawdown, splits, payouts, rule clarity, and scaling.",
  headers: {
    otherFirms: "OTHER FIRMS",
    otherFirmsSub: "The old way",
    ours: "FLEX FUND",
    oursSub: "How it should work",
  },
  rows: {
    drawdownRules: {
      topic: "Drawdown rules",
      legacy: "Hidden trailing drawdowns close your account on a winning day.",
      ours: "Static drawdown on starting balance. No surprises.",
    },
    profitSplits: {
      topic: "Profit splits",
      legacy: "Promised splits drop after the first payout.",
      ours: "80% from day one. Up to 90% with the optional add-on.",
    },
    payoutSpeed: {
      topic: "Payout speed",
      legacy: 'Vague "we\'ll get back to you" timelines.',
      ours: "Regular payout windows. Processed in 48–72 business hours.",
    },
    ruleClarity: {
      topic: "Rule clarity",
      legacy: "Soft rules invented after a breach. Surprise news bans and shifting goalposts.",
      ours: "One rulebook. Documented up front. Applied consistently.",
    },
    accountScaling: {
      topic: "Account scaling",
      legacy: "Capped at $200K with arbitrary milestones.",
      ours: "Scale up to $1M with documented growth steps.",
    },
  },
};

export const landingConfigurator: LandingConfiguratorContent = {
  title: { lead: "Configure your ", highlight: "evaluation." },
  sub: "Pick a model, pick a size, and see the exact terms you'll trade.",
  models: { twoStep: "2-Step", oneStep: "1-Step" },
  accountSize: "ACCOUNT SIZE",
  dailyDrawdown: "DAILY DRAWDOWN",
  maxDrawdown: "MAX DRAWDOWN",
  ticketLabel: "TICKET",
  youPay: "YOU PAY",
};
